import styles from './Header.module.scss';

type Props = {
  text: string;
};

export default function Header({ text }: Props) {
  return (
    <div className={styles.Header_container}>
      <div className={styles.text}>{text}</div>
    </div>
  );
}
